import { changeTheme } from "../../../features/themeSlice";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "../../ToolTip";
import { FiMoon, FiSun } from "react-icons/fi";

const ChangeTheme = () => {
  const theme = useSelector((state) => state?.theme?.mode);
  const dispatch = useDispatch();


  const selectTheme = () => {
    if (
      localStorage.theme !== "dark" ||
      (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
      dispatch(changeTheme("dark"));
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
      dispatch(changeTheme("light"));
    }
  };

  return (
    <Tooltip
      content={
        theme === "dark"
          ? "حالت روز"
          : "حالت شب"
      }
    >
      <button
        className="py-2 transform scale-125"
        data-tip="React-tooltip"
        data-for="theme"
        onClick={selectTheme}
        aria-label="تغییر رنگ قالب"
      >
        {theme === "dark" ? (
          <FiSun aria-hidden="true" />
        ) : (
          <FiMoon aria-hidden="true" />
        )}
      </button>
    </Tooltip>
  );
};

export default ChangeTheme;